import React, { lazy, Suspense, useEffect } from "react";
import "./assets/css/index.css";
import Body from "./components/Shared/Body";
import MenuNavbar from "./components/Shared/MenuNavbar";
import FeedBack from "./components/Pages/FeedBack";
import Error from "./components/Pages/Error";
import Contact from "./components/Pages/Contact";
import EditVideo from "./components/Pages/EditVideo";
const VideoPage = lazy(() => import("./components/Pages/VideoPage"));
import Subscribed from "./components/Pages/Subscribed";
const Login = lazy(() => import("./components/Pages/Login"));
const SignUp = lazy(() => import("./components/Pages/SignUp"));
const YourVideos = lazy(() => import("./components/Pages/YourVideos"));
const TrendVideos = lazy(() => import("./components/Pages/TrendVideos"));
const ChannelPage = lazy(() => import("./components/Pages/ChannelPage"));
const Settings = lazy(() => import("./components/Pages/Settings"));
const Playlists = lazy(() => import("./components/Pages/Playlists"));
const PlaylistDetail = lazy(() => import("./components/Pages/PlaylistDetail"));
const WatchLater = lazy(() => import("./components/Pages/WatchLater"));
const History = lazy(() => import("./components/Pages/History"));

import { createHashRouter, Outlet, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Provider, useDispatch } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
import NewVideo from "./components/Pages/NewVideo";
import Reset from "./components/Pages/Reset";
import ForgotPassword from "./components/Pages/ForgotPassword";
import { checkAuth } from "./slices/authSlice";

const store = configureStore({
  reducer: rootReducer
});

function AppShell() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(checkAuth());
  }, [dispatch]);

  return (
    <div className="app-container min-h-screen w-full bg-indigo overflow-x-hidden flex flex-col">
      <MenuNavbar />
      <main className="flex-1 w-full max-w-full">
        <Outlet />
      </main>
    </div>
  );
}

export default function App() {
  return (
    <Provider store={store}>
      <AppShell />
      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
      />
    </Provider>
  );
}

export const appRouter = createHashRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <Error />,
    children: [
      {
        path: "/",
        element: <Body />,
      },
      {
        path: "/trending",
        element: (
          <Suspense>
            <TrendVideos />
          </Suspense>
        ),
      },
      {
        path: "/subscribed",
        element: <Subscribed />,
      },
      {
        path: "/feedback",
        element: <FeedBack />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/video/:vID",
        element: (
          <Suspense>
            <VideoPage />
          </Suspense>
        ),
      },
      {
        path: "/yourvideos",
        element: (
          <Suspense>
            <YourVideos />
          </Suspense>
        ),
      },
      {
        path: "/yourvideos/edit/:videoId",
        element: <EditVideo />,
      },
      {
        path: "/login",
        element: (
          <Suspense>
            <Login />
          </Suspense>
        ),
      },
      {
        path: "/register",
        element: (
          <Suspense>
            <SignUp />
          </Suspense>
        ),
      },
      {
        path: "/newvideo",
        element: <NewVideo />,
      },
      {
        path: "/forgotpassword",
        element: <ForgotPassword />,
      },
      {
        path: "/resetpassword/:token",
        element: <Reset />,
      },
      {
        path: "/channel/:userId",
        element: (
          <Suspense>
            <ChannelPage />
          </Suspense>
        ),
      },
      {
        path: "/settings",
        element: (
          <Suspense>
            <Settings />
          </Suspense>
        ),
      },
      {
        path: "/playlists",
        element: (
          <Suspense>
            <Playlists />
          </Suspense>
        ),
      },
      {
        path: "/playlists/:id",
        element: (
          <Suspense>
            <PlaylistDetail />
          </Suspense>
        ),
      },
      {
        path: "/watchlater",
        element: (
          <Suspense>
            <WatchLater />
          </Suspense>
        ),
      },
      {
        path: "/history",
        element: (
          <Suspense>
            <History />
          </Suspense>
        ),
      },
    ],
  },
]);